import axios from "axios";
import { apiPath } from "../../constants/config";

let token = localStorage.getItem("accessToken");
let config_headers = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  products: [],
  sales: [],
  statePayments: [],
  totalOrders: 0
};
const getters = {
  products: state => state.products,
  sales: state => state.sales,
  statePayments: state => state.statePayments,
  totalOrders: state => state.totalOrders
};
const mutations = {
  setProductsSuccess(state, payload) {
    // console.log("FROMMUTATEPRODUCTS");
    // console.log(payload);
    state.products = payload.products;
  },
  setSalesSuccess(state, payload) {
    // console.log("FROMMUTATEPRODUCTS");
    // console.log(payload);
    state.sales = payload.sales;
  },
  setStatePayments(state, payload) {
    // console.log("FROMMUTATEPRODUCTS");
    // console.log(payload);
    state.statePayments = payload.statePayments;
  },
  setTotalOrders(state, payload) {
    // console.log("FROMMUTATEPRODUCTS");
    // console.log(payload);
    state.totalOrders = payload.total;
  }
};

const actions = {
  //   setProducts({ commit }, payload) {
  //     commit("setProductsSuccess", payload);
  //   },
  //   setSales({ commit }, payload) {
  //     commit("setSalesSuccess", payload);
  //   },
  getProducts({ commit }, payload) {
    return axios
      .get(`${apiPath}/statistiques?restaurant=${payload}`, config_headers)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("setProductsSuccess", {
            products: res.res
          });
          return res;
        } else {
          console.log(res);
          return res;
        }
      });
  },
  getSales({ commit }, payload) {
    return axios
      .get(
        `${apiPath}/statistiques/sales?restaurant=${payload}`,
        config_headers
      )
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("setSalesSuccess", {
            sales: res.sales
          });
          return res;
        } else {
          console.log(res);
          return res;
        }
      });
  },
  getStatePayments({ commit }, payload) {
    return axios
      .get(
        `${apiPath}/statistiques/statePayments?restaurant=${payload.restaurant}&date=${payload.date}`,
        config_headers
      )
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("setStatePayments", {
            statePayments: res.res
          });
          commit("setTotalOrders", {
            total: res.total
          });
          return res;
        } else {
          console.log(res);
          return res;
        }
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
